module.exports = __webpack_public_path__ + "static/redboost-logo-7c771404ac35a3bf6bcb2e130cb7b731.png";